import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = graphql.transformers.OUT.nonNull(
  transformers.combine(
    graphql.transformers.IN.enumeration<
      ents.extra.space.Record.History.Action,
      graphql.schema.SpaceRecordHistoryAction
    >({
      [ents.extra.space.Record.History.Action.OrganizationAssignUpdated]:
        graphql.schema.SpaceRecordHistoryAction.OrganizationAssignUpdated,
      [ents.extra.space.Record.History.Action.SignedOff]:
        graphql.schema.SpaceRecordHistoryAction.SignedOff,
      [ents.extra.space.Record.History.Action.SignedOffLite]:
        graphql.schema.SpaceRecordHistoryAction.SignedOffLite,
      [ents.extra.space.Record.History.Action.Unlocked]:
        graphql.schema.SpaceRecordHistoryAction.Unlocked,
      [ents.extra.space.Record.History.Action.Updated]:
        graphql.schema.SpaceRecordHistoryAction.Updated,
      [ents.extra.space.Record.History.Action.FunctionalUsageUpdated]:
        graphql.schema.SpaceRecordHistoryAction.FunctionalUsageUpdated,
      [ents.extra.space.Record.History.Action.OccupantsUpdated]:
        graphql.schema.SpaceRecordHistoryAction.OccupantsUpdated,
      [ents.extra.space.Record.History.Action.ResponsiblePersonsUpdated]:
        graphql.schema.SpaceRecordHistoryAction.ResponsiblePersonsUpdated,
      [ents.extra.space.Record.History.Action.LabsUpdated]:
        graphql.schema.SpaceRecordHistoryAction.LabsUpdated,
      [ents.extra.space.Record.History.Action.ClusterAssigned]:
        graphql.schema.SpaceRecordHistoryAction.ClusterAssigned,
      [ents.extra.space.Record.History.Action.ClusterRemoved]:
        graphql.schema.SpaceRecordHistoryAction.ClusterRemoved,
    }),
    graphql.transformers.OUT.enumeration<
      graphql.schema.SpaceRecordHistoryAction,
      ents.extra.space.Record.History.Action
    >({
      [graphql.schema.SpaceRecordHistoryAction.OrganizationAssignUpdated]:
        ents.extra.space.Record.History.Action.OrganizationAssignUpdated,
      [graphql.schema.SpaceRecordHistoryAction.SignedOff]:
        ents.extra.space.Record.History.Action.SignedOff,
      [graphql.schema.SpaceRecordHistoryAction.SignedOffLite]:
        ents.extra.space.Record.History.Action.SignedOffLite,
      [graphql.schema.SpaceRecordHistoryAction.Unlocked]:
        ents.extra.space.Record.History.Action.Unlocked,
      [graphql.schema.SpaceRecordHistoryAction.Updated]:
        ents.extra.space.Record.History.Action.Updated,
      [graphql.schema.SpaceRecordHistoryAction.FunctionalUsageUpdated]:
        ents.extra.space.Record.History.Action.FunctionalUsageUpdated,
      [graphql.schema.SpaceRecordHistoryAction.OccupantsUpdated]:
        ents.extra.space.Record.History.Action.OccupantsUpdated,
      [graphql.schema.SpaceRecordHistoryAction.ResponsiblePersonsUpdated]:
        ents.extra.space.Record.History.Action.ResponsiblePersonsUpdated,
      [graphql.schema.SpaceRecordHistoryAction.LabsUpdated]:
        ents.extra.space.Record.History.Action.LabsUpdated,
      [graphql.schema.SpaceRecordHistoryAction.ClusterAssigned]:
        ents.extra.space.Record.History.Action.ClusterAssigned,
      [graphql.schema.SpaceRecordHistoryAction.ClusterRemoved]:
        ents.extra.space.Record.History.Action.ClusterRemoved,
    }),
  ),
)
